// src/api/payments.api.js
import { apiFetch } from '../api.js'

/**
 * Récupère toutes les échéances d'un client
 * GET /api/payments/customers/:uid/installments
 */
export function apiGetCustomerInstallments(uid, { status, from, to } = {}) {
  const qs = new URLSearchParams()
  if (status) qs.set('status', status)
  if (from) qs.set('from', from)
  if (to) qs.set('to', to)

  const suffix = qs.toString() ? `?${qs.toString()}` : ''
  return apiFetch(`/api/payments/customers/${uid}/installments${suffix}`)
}

/**
 * Enregistrer un paiement (encaissement d'une tranche)
 * POST /api/payments/installments/:id/pay
 * body: { amount, payment_method, paid_at, note }
 *
 * ✅ FIX: on passe un OBJET (pas une string) pour que core.js ajoute Content-Type
 * ✅ + sécurité: on force un payload clean
 */
export function apiPostInstallmentPayment(id, body) {
  if (!id) throw new Error('installment_id manquant')
  const paymentMethod = body?.payment_method || body?.method
  if (!paymentMethod) throw new Error('payment_method manquant (front)')

  const payload = {
    amount: Number(body?.amount),
    payment_method: paymentMethod,
    paid_at: body?.paid_at || new Date().toISOString(),
    note: body?.note ?? undefined,
  }

  console.log('🔄 payments.api - Envoi paiement:', { id, payload })

  if (!Number.isFinite(payload.amount) || payload.amount <= 0) {
    throw new Error('Montant invalide (front)')
  }

  return apiFetch(`/api/payments/installments/${id}/pay`, {
    method: 'POST',
    body: payload, // ✅ objet, core.js va JSON.stringify + Content-Type
  })
}

/**
 * Rappels d'échéances (à venir / en retard)
 * GET /api/payments/reminders?days=7
 */
export function apiGetReminders(days = 7) {
  const d = Number.isFinite(Number(days)) ? Number(days) : 7
  return apiFetch(`/api/payments/reminders?days=${d}`)
}
